import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import {
  Cancel,
  CheckCircle,
  Close,
  Delete,
  Download,
  FindInPage,
  Send,
  Upload,
} from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Fade,
  IconButton,
  Modal,
  TextField,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import DescriptionModal from "../components/descriptionModal.tsx";
import "../css/animatedBtn.css";
import getReq from "../interface/getRequestinterface";
import postReq from "../interface/postRequestinterface";
import { setCounter } from "../redux/typeSelector";
import { setImg } from "../redux/uploadedImg";
import { getRequest, postRequest } from "../request";
import Loading from "./loading";
const templateImg = require("../assets/image/treebackground.jpg");
const style = {
  formTitle: {
    fontWeight: "bold !important",
  },
  formDescription: {
    color: "#9b9b9b",
  },
  formContainer: {
    padding: "1rem !important",
    border: "3px solid #748DA6",
    borderRadius: "10px",
    backgroundColor: "#f1f7ff59",
    height: "fit-content",
  },
  gridBox: {
    display: "grid",
    gridTemplateColumns: "40% 40%",
    columnGap: "5%",
    rowGap: "3%",
    justifyContent: "space-around",
    // marginTop:'2rem'
  },
  mobileGridBox: {
    display: "grid",
    gridTemplateColumns: "90%",
    // columnGap:'5%',
    rowGap: "3%",
    justifyContent: "center",
    marginTop: "2rem",
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    p: 4,
    bgcolor: "background.paper",
  },
  txtField: {
    width: "100%",
  },
  headerContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  stateHandler: {
    display: "flex",
  },
  stateType: { fontWeight: "bold" },
};
interface FormData {
  clientComment: string;
  expertComment: string;
  fileName: string;
  fileType: string;
  requestCode: number;
  uploudTime: string;
  formId: number;
  state: number;
  type: number;
}
function SanaForms() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const count = useSelector((state: any) => state.typeSelector.index);
  const uploadedImg = useSelector((state: any) => state.uploadedImg.img);
  const [imgFile, setImgFile] = useState<File>();
  const [isShowDescModal, setIsShowDescModal] = useState(false);
  const [uploadedForms, setUploadedForms] = useState<Array<FormData>>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [isProgress, setIsProgress] = useState<boolean>(false);
  const [desc, setDesc] = useState<string>("");
  const requestId = localStorage.getItem("user");
  const cacheRtl = useMemo(() => {
    return createCache({
      key: "muirtl",
      stylisPlugins: [prefixer, rtlPlugin],
    });
  }, []);

  const cashPeymentRequest = require("../assets/sana/cashPeymentRequest.docx");
  const closedForm = require("../assets/sana/closedForm.docx");
  const ehraz_hoviat = require("../assets/sana/ehraz_hoviat.docx");
  const introForm = require("../assets/sana/introForm.docx");
  const sodoor_havale_arzi = require("../assets/sana/sodoor_havale_arzi.docx");

  const formsList = [
    {
      id: 12,
      title: "فرم احراز هویت صرافی",
      description: "فرم دریافتی از سایت را در این قسمت بارگزاری نمایید",
      form: ehraz_hoviat,
    },
    {
      id: 7,
      title: "فرم درخواست پرداخت کش",
      description: "فرم دریافتی از سایت را در این قسمت بارگزاری نمایید",
      form: cashPeymentRequest,
    },
    {
      id: 0,
      title: "فرم درخواست پرداخت حواله ارزی",
      description: "فرم دریافتی از سایت را در این قسمت بارگزاری نمایید",
      form: sodoor_havale_arzi,
    },
    {
      id: 11,
      title: "نامه مختومه",
      description: "فرم مورد نظر را بارگزاری نمایید",
      form: closedForm,
    },
    {
      id: 13,
      title: "مجوز صرافی",
      description: "فرم دریافتی از سایت را در این قسمت بارگزاری نمایید",
    },
    {
      id: 5,
      title: "نامه معرفی نماینده",
      description: "فرم دریافتی از سایت را در این قسمت بارگزاری نمایید",
      form: introForm,
    },
    {
      id: 9,
      title: "شناسنامه",
      description: "فرم دریافتی از سایت را در این قسمت بارگزاری نمایید",
    },
    {
      id: 10,
      title: "کارت ملی",
      description: "فرم دریافتی از سایت را در این قسمت بارگزاری نمایید",
    },
  ];
  // const getForms = async()=>{
  //     // const getReq : getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Form/GetForms/${requestId}`) as getReq;
  //     const getReq : getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Form/GetAllForms`) as getReq;
  //     console.log(getReq);
  // }
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isTablet = useMediaQuery({
    query: "(max-width: 768px)",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });
  useEffect(() => {
    loadForms();
  }, []);

  const loadForms = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/Form/GetFormsByUser`
    )) as getReq;
    if (!error) {
      setUploadedForms(data);
      setTimeout(() => {
        setIsLoading(true);
      }, 1500);
    } else {
      toast.error(error);
    }
  };

  // const handleUploadFile=(e)=>{
  //   const file = e.target.files[0];
  //   setImgFile(e.target.files[0]);
  //   const reader = new FileReader();
  //   let base64String ='';
  //   reader.onload = function () {
  //     const res :string = reader.result as string;
  //       base64String = res?.replace("data:", "").replace(/^.+,/, "");
  //       dispatch(setImg(base64String));
  //   }
  //   reader.readAsDataURL(file);
  // }
  const handleDeleteForm = () => {
    dispatch(setCounter(-1));
    dispatch(setImg(""));
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  const handleShowImageModal = () => {
    setOpenModal(true);
  };
  const handleSendFile = async () => {
    // const formData = new FormData();
    setIsProgress(true);
    const formData = new FormData();
    formData.append("MyImage", imgFile!);
    formData.append("Description", desc);
    formData.append("RequestCode", requestId!);
    formData.append("type", count.toString());
    const postResponse: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/Form`,
      formData
    )) as postReq;
    if (postResponse.error) {
      toast.error(postResponse.error);
    } else {
      toast.success("فایل با موفقیت آپلود شد.");
      dispatch(setCounter(-1));
      dispatch(setImg(""));
      setIsProgress(false);
      window.location.reload();
    }
  };

  const handleDownloadFile = (index) => {
    const token = localStorage.getItem("token");
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/Form/GetFile/${
      uploadedForms.find((x) => x.type === index)?.formId
    }`; // Replace with your API endpoint
    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Set the content type if needed
    };
    // Make a GET request with the Authorization header
    fetch(apiUrl, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response;
      })
      .then((response) => response.blob())
      .then((blob) => {
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // For IE and Edge browsers
          window.navigator.msSaveBlob(blob, "image.png");
        } else {
          // Create a URL for the blob data
          const url = window.URL.createObjectURL(blob);

          // Create an anchor element for downloading
          const a = document.createElement("a");
          a.href = url;
          a.download = "image.jpg"; // You can specify the desired filename here

          // Programmatically trigger a click event on the anchor element
          a.click();

          // Clean up by revoking the URL object
          window.URL.revokeObjectURL(url);
        }
      })
      .catch((error) => {
        console.error("Error downloading image:", error);
      });
  };

  const handleUploadFile = (e) => {
    const file = e.target.files[0];
    setImgFile(e.target.files[0]);
    const reader = new FileReader();
    let base64String = "";
    reader.onload = function () {
      const res: string = reader.result as string;
      base64String = res?.replace("", "").replace(/^.+,/, "");
      dispatch(setImg(base64String));
    };
    reader.readAsDataURL(file);
  };

  return (
    <CacheProvider value={cacheRtl}>
      <div className="background">
        {isLoading ? (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <div
                onClick={() => setIsShowDescModal(true)}
                className="animated-button8"
              >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                توضیحات
              </div>
            </Box>
            <Box sx={isDesktop ? style.gridBox : style.mobileGridBox}>
              {formsList.map((form, index) => (
                <Box key={index} sx={style.formContainer}>
                  <Box sx={style.headerContainer}>
                    <Typography
                      variant="h6"
                      color="initial"
                      sx={style.formTitle}
                    >
                      {form.title}
                    </Typography>
                    <Box sx={{ display: "flex" }}>
                      <Typography variant="body1" color="initial">
                        وضعیت:
                      </Typography>
                      {uploadedForms.find((x) => x.type === form.id) ? (
                        <Box>
                          {uploadedForms.find((x) => x.type === form.id)
                            ?.state === 0 ? (
                            <Box sx={style.stateHandler}>
                              <Typography
                                variant="body1"
                                sx={style.stateType}
                                color="initial"
                              >
                                در حال بررسی
                              </Typography>
                              <FindInPage sx={{ color: "#707070" }} />
                            </Box>
                          ) : null}
                          {uploadedForms.find((x) => x.type === form.id)
                            ?.state === 1 ? (
                            <Box sx={style.stateHandler}>
                              <Typography
                                variant="body1"
                                sx={style.stateType}
                                color="initial"
                              >
                                تایید شده
                              </Typography>
                              <CheckCircle sx={{ color: "green" }} />
                            </Box>
                          ) : null}
                          {uploadedForms.find((x) => x.type === form.id)
                            ?.state === 2 ? (
                            <Box sx={style.stateHandler}>
                              <Typography
                                variant="body1"
                                sx={style.stateType}
                                color="initial"
                              >
                                تایید نشده
                              </Typography>
                              <Cancel sx={{ color: "#bf0639" }} />
                            </Box>
                          ) : null}
                        </Box>
                      ) : (
                        <Typography
                          variant="body1"
                          sx={style.stateType}
                          color="initial"
                        >
                          ارسال نشده
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Typography
                    variant="caption"
                    color="initial"
                    sx={style.formDescription}
                  >
                    {form.description}
                  </Typography>
                  <Box
                    sx={
                      form.form || uploadedForms.find((x) => x.type === form.id)
                        ? {
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }
                        : {
                            display: "flex",
                            width: "100%",
                            justifyContent: "end",
                          }
                    }
                  >
                    {uploadedForms.find((x) => x.type === form.id) ? (
                      <Box sx={{ display: "flex" }}>
                        <Box
                          sx={{
                            height: "4rem",
                            alignItems: "center",
                            display: "flex",
                            marginLeft: "5px",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ paddingRight: "5px" }}
                          >
                            فایل آپلود شده
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ height: "fit-content" }}
                            color="primary"
                            onClick={() => handleDownloadFile(form.id)}
                          >
                            دانلود فایل آپلود شده <Download />
                          </Button>
                        </Box>
                      </Box>
                    ) : count === index && imgFile ? null : form.form ? (
                      <Box sx={{ display: "flex" }}>
                        <Box
                          sx={{
                            height: "4rem",
                            alignItems: "center",
                            display: "flex",
                            marginLeft: "5px",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ paddingRight: "5px" }}
                          >
                            {uploadedForms.find((x) => x.type === form.id)
                              ? "فایل آپلود شده"
                              : "نمونه فایل"}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ height: "fit-content" }}
                            color="secondary"
                            onClick={() => window.open(form.form)}
                          >
                            دانلود نمونه فایل
                            <Download />
                          </Button>
                        </Box>
                      </Box>
                    ) : null}
                    {/* {
                  count === index && imgFile?
                    <Box sx={{display:'flex'}}>
                        <Box 
                          sx={{
                            height:'4rem',
                            alignItems:'center',
                            display:'flex',
                            marginLeft:'5px'
                            }}
                          >
                          <Typography variant="body1" >فایل آپلود شده</Typography>
                        </Box>
                         <div 
                          className='imageList'
                          onMouseEnter={()=>setHovered(index+1)}
                          onMouseLeave={()=>setHovered(0)}
                        >
                          <img
                            // src='https://charismaex.ir:200/api/Form/GetFile/12'
                            src={'data:image/png;base64, '+uploadedImg}
                            alt=""
                            style={{
                              width: "5rem",
                              height: "4rem",
                              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
                              borderRadius: '3px'
                            }}
                          />
                            {
                            hovered === index+1?
                            <Tooltip title="نمایش عکس بارگزاری شده ">
                              <IconButton aria-label="" className="imgBtn"
                                onClick={()=>handleShowImageModal()}
                                sx={{
                                  backgroundColor: '#00000025',
                                }}
                                >
                                <Visibility sx={{color:'#1e1e1e'}}/>
                              </IconButton>
                            </Tooltip>
                            :null
                            }  
                          <div>
                          </div>
                        </div> 
                    </Box>
                  :null
                } */}
                    <Box
                      sx={
                        isDesktop
                          ? {
                              // height:'4rem',
                              // top:'2rem',
                              position: "relative",
                            }
                          : {
                              display: "flex",
                              flexDirection: "column",
                              position: "relative",
                              top: "0rem",
                            }
                      }
                    >
                      <label htmlFor="upload-photo">
                        <input
                          style={{ display: "none" }}
                          id="upload-photo"
                          name="upload-photo"
                          type="file"
                          onChange={(e) => handleUploadFile(e)}
                        />
                        {count === form.id && imgFile ? null : (
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setTimeout(() => {
                                dispatch(setCounter(form.id));
                              }, 500);
                            }}
                            sx={{ color: "green" }}
                            component="span"
                          >
                            بارگزاری فایل
                            <Upload />
                          </Button>
                        )}
                      </label>
                      {count === form.id && imgFile ? (
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={handleDeleteForm}
                        >
                          حذف فایل
                          <Delete />
                        </Button>
                      ) : null}
                      {count === form.id && imgFile ? (
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleSendFile}
                        >
                          ارسال فایل
                          {isProgress ? (
                            <CircularProgress
                              style={{ width: "25px", height: "25px" }}
                              color="inherit"
                            />
                          ) : (
                            <Send />
                          )}
                        </Button>
                      ) : null}
                    </Box>
                  </Box>
                  {count === form.id && imgFile ? (
                    <TextField
                      label="توضیحات"
                      multiline
                      rows={4}
                      // dir='rtl'
                      sx={style.txtField}
                      value={desc}
                      onChange={(e) => setDesc(e.target.value)}
                    />
                  ) : null}
                </Box>
              ))}
            </Box>
          </Box>
        ) : (
          <div
            style={{
              width: "100vw",
              height: "calc( 100vh - 64px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading type="cylon" color="#000" />
          </div>
        )}
        <Modal open={openModal} onClose={handleClose} closeAfterTransition>
          <Fade in={openModal}>
            <Box sx={style.modalStyle}>
              <IconButton
                color="default"
                onClick={() => setOpenModal(false)}
                sx={{ position: "absolute" }}
              >
                <Close sx={{ color: "#c5c5c5", fontSize: "3rem" }} />
              </IconButton>
              <img
                src={"data:image/png;base64, " + uploadedImg}
                alt=""
                style={{ width: "100%" }}
              />
            </Box>
          </Fade>
        </Modal>
        <Modal
          open={isShowDescModal}
          onClose={() => setIsShowDescModal(false)}
          closeAfterTransition
        >
          <Fade in={isShowDescModal}>
            <Box sx={style.modalStyle}>
              <DescriptionModal />
            </Box>
          </Fade>
        </Modal>
      </div>
    </CacheProvider>
  );
}

export default SanaForms;
